// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2t6Je","inner":"Header_inner__t9aII","logo":"Header_logo__G+ea6"};